import { Platform } from "react-native";

import WebDatePicker from "./DatePicker.web";
import NativeDatePicker from "./DatePicker.native";

export default Platform.OS === "web" ? WebDatePicker : NativeDatePicker;
